import { render, staticRenderFns } from "./modelThree.vue?vue&type=template&id=8e2b8b58&scoped=true&"
import script from "./modelThree.vue?vue&type=script&lang=js&"
export * from "./modelThree.vue?vue&type=script&lang=js&"
import style0 from "./modelThree.vue?vue&type=style&index=0&id=8e2b8b58&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e2b8b58",
  null
  
)

export default component.exports